import commonConstants from "$/data/common";
import {
  Box,
  Button,
  LinearProgress,
  Stack,
  Typography,
  linearProgressClasses,
  useTheme,
} from "@mui/material";
import React from "react";
import { Link } from "react-router-dom";

function CreditProgress({ credits, hideButton = false }) {
  const theme = useTheme();
  return (
    <Box flex={1}>
      <Stack direction="row" spacing={1} justifyContent="space-between">
        <Typography variant="subtitle2" mb={1} color="gray">
          Free Credits:{" "}
          <Typography color={credits > 1 ? "primary" : "error"} display="inline-block">
            {credits > commonConstants.FREE_CREDITS ? credits : Math.max(credits, 0)}
          </Typography>
          {credits > commonConstants.FREE_CREDITS
            ? ""
            : ` / ${commonConstants.FREE_CREDITS}`}
        </Typography>
        {!hideButton && (
          <Button component={Link} to="/pricing" size="small">
            Upgrade
          </Button>
        )}
      </Stack>
      <LinearProgress
        color="primary"
        value={Math.max(commonConstants.FREE_CREDITS, Math.min(credits * 40, 100))}
        variant="determinate"
        aria-label="Credits Available"
        sx={{
          height: 10,
          borderRadius: 5,
          [`&.${linearProgressClasses.colorPrimary}`]: {
            backgroundColor: theme.palette.grey[300],
          },
          [`& .${linearProgressClasses.bar}`]: {
            borderRadius: 5,
            backgroundColor:
              credits > 1 ? theme.palette.primary.main : theme.palette.error.light,
          },
          mb: 2,
        }}
      />
    </Box>
  );
}

export default CreditProgress;
